const VideoPlayerState = {
  url: null,
  isBuffering: false,
  playing: true,
  duration: 0,
  playedSeconds: 0,
  played: 0,
  seeking: false
};

const VideoReducer = (state, action) => {
  switch (action.type) {
    case 'SET_VIDEO_SEEKING':
      return {
        ...state,
        seeking: action.payload
      };
    case 'SET_VIDEO_BUFFERING':
      return {
        ...state,
        isBuffering: action.payload
      };
    case 'SET_VIDEO_DURATION':
      return {
        ...state,
        duration: action.payload
      };
    case 'SET_VIDEO_PLAYED_SECONDS':
      return {
        ...state,
        playedSeconds: action.payload
      };
    case 'SET_VIDEO_ENDED':
      return {
        ...state,
        playing: false
      };
    case 'SET_VIDEO_PAUSED':
      return {
        ...state,
        playing: false
      };
    case 'SET_VIDEO_PLAY':
      return {
        ...state,
        playing: true
      };
    case 'SET_VIDEO_PLAYED':
      return {
        ...state,
        played: action.payload
      };
    case 'TOGGLE_VIDEO_PLAY_PAUSE':
      return {
        ...state,
        playing: !state.playing
      };
    default:
      return state;
  }
};

export { VideoPlayerState, VideoReducer };
